import React, {useEffect, useState, useRef} from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import axios from 'axios';
import "./PublicSlideshow.css";
import {boatList} from '../refs/lists';

function PublicSlideshow() {

  const defaultTable = <>
    <Table>
      <Thead>
        <Tr>
          <Th>#</Th>
          <Th>Team</Th>
          <Th>Points</Th>
        </Tr>
      </Thead>
    </Table>
    <p>Results on the way...</p>
  </>

  const billfishDay3Table = <>
    <Table>
      <Thead>
        <Tr>
          <Th>#</Th>
          <Th>Team</Th>
          <Th>Points</Th>
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td>1</Td>
          <Td>Vamonos - Clement</Td>
          <Td>550</Td>
        </Tr>
        <Tr>
          <Td>2</Td>
          <Td>Backlash74</Td>
          <Td>550</Td>
        </Tr>
        <Tr>
          <Td>3</Td>
          <Td>Stabilized</Td>
          <Td>500</Td>
        </Tr>
        <Tr>
          <Td>4</Td>
          <Td>Rebecca</Td>
          <Td>500</Td>
        </Tr>
        <Tr>
          <Td>5</Td>
          <Td>Instigator</Td>
          <Td>400</Td>
        </Tr>
      </Tbody>
    </Table>
  </>

  const overallBillfishTable = <>
    <Table>
      <Thead>
        <Tr>
          <Th>#</Th>
          <Th>Team</Th>
          <Th>Points</Th>
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td>1</Td>
          <Td>Rebecca</Td>
          <Td>1850</Td>
        </Tr>
        <Tr>
          <Td>2</Td>
          <Td>Backlash74</Td>
          <Td>1250</Td>
        </Tr>
        <Tr>
          <Td>3</Td>
          <Td>Poured Out</Td>
          <Td>1250</Td>
        </Tr>
        <Tr>
          <Td>4</Td>
          <Td>Vamonos - Clement</Td>
          <Td>1150</Td>
        </Tr>
        <Tr>
          <Td>5</Td>
          <Td>Ambush</Td>
          <Td>850</Td>
        </Tr>
      </Tbody>
    </Table>
  </>

  const tunaTable = <>
    <Table>
      <Thead>
        <Tr>
          <Th>#</Th>
          <Th>Team</Th>
          <Th>Points</Th>
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td>1</Td>
          <Td>Overnight Celebrity</Td>
          <Td>15</Td>
        </Tr>
        <Tr>
          <Td>2</Td>
          <Td>Trophy Club</Td>
          <Td>12</Td>
        </Tr>
        <Tr>
          <Td>3</Td>
          <Td>Poured Out</Td>
          <Td>12</Td>
        </Tr>
        <Tr>
          <Td>4</Td>
          <Td>Ambush</Td>
          <Td>12</Td>
        </Tr>
        <Tr>
          <Td>5</Td>
          <Td>Ambush</Td>
          <Td>11</Td>
        </Tr>
      </Tbody>
    </Table>
  </>

  const grandSlamTable = <>
    <Table>
    <Thead>
      <Tr>
        <Th>#</Th>
        <Th>Team</Th>
        <Th>Blue Marlin</Th>
        <Th>White Marlin</Th>
        <Th>Sailfish</Th>
      </Tr>
    </Thead>
    <Tbody>
      <Tr>
        <Td>1</Td>
        <Td>Poured Out</Td>
        <Td>2023-07-14 16:17:00</Td>
        <Td>2023-07-14 15:05:00</Td>
        <Td>2023-07-13 16:55:00</Td>
      </Tr>
      <Tr>
        <Td>2</Td>
        <Td>Vamonos - Clement</Td>
        <Td>2023-07-14 19:22:00</Td>
        <Td>2023-07-14 13:35:00</Td>
        <Td>2023-07-15 06:56:00</Td>
      </Tr>
      <Tr>
        <Td>3</Td>
        <Td>Backlash74</Td>
        <Td>2023-07-14 15:26:00</Td>
        <Td>2023-07-15 08:02:00</Td>
        <Td>2023-07-14 08:00:00</Td>
      </Tr>
      <Tr>
        <Td>4</Td>
        <Td>Instigator</Td>
        <Td>2023-07-15 09:25:00</Td>
        <Td>2023-07-13 15:13:00</Td>
        <Td>2023-07-13 17:27:00</Td>
      </Tr>
      <Tr>
        <Td>5</Td>
        <Td>See-Mah</Td>
        <Td>2023-07-14 17:13:00</Td>
        <Td>2023-07-15 09:43:00</Td>
        <Td>2023-07-13 16:26:00</Td>
      </Tr>
    </Tbody>
    </Table>
    </>

  const buildPointsTable = (resultsList) => {
    return <>
      <Table>
        <Thead>
          <Tr>
            <Th>#</Th>
            <Th>Team</Th>
            <Th>Points</Th>
          </Tr>
        </Thead>
        <Tbody>
          {resultsList.map((team, i) => {
            return (
              <Tr>
                <Td>{i+1}</Td>
                <Td>{team.boatName}</Td>
                <Td>{team.points}</Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </>
  }

  const buildGrandSlamTable = (resultsList) => {
    return <>
      <Table>
        <Thead>
          <Tr>
            <Th>#</Th>
            <Th>Team</Th>
            <Th>Blue Marlin</Th>
            <Th>White Marlin</Th>
            <Th>Sailfish</Th>
          </Tr>
        </Thead>
        <Tbody>
          {resultsList.map((team, i) => {
            return (
              <Tr>
                <Td>{i+1}</Td>
                <Td>{team['boatName']}</Td>
                <Td>{team['blueMarlinTime']}</Td>
                <Td>{team['whiteMarlinTime']}</Td>
                <Td>{team['sailfishTime']}</Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </>
  }

  const [tournamentGrandChampionTable, setTournamentGrandChampionTable] = useState(defaultTable);
  // const [billfishOverallTable, setBillfishOverallTable] = useState(defaultTable);
  const [billfishDay1Table, setBillfishDay1Table] = useState(defaultTable);
  const [billfishDay2Table, setBillfishDay2Table] = useState(defaultTable);
  // const [billfishDay3Table, setBillfishDay3Table] = useState(defaultTable);
  const [blueMarlinTable, setBlueMarlinTable] = useState(defaultTable);
  const [whiteMarlinTable, setWhiteMarlinTable] = useState(defaultTable);
  const [sailfishTable, setSailfishTable] = useState(defaultTable);
  const [dolphinTable, setDolphinTable] = useState(defaultTable);
  const [wahooTable, setWahooTable] = useState(defaultTable);
  // const [tunaTable, setTunaTable] = useState(tunaTable);

  let results = [
    {
      title: "Tournament Grand Champion",
      description: "Winner takes all. Earliest catch for tie-breakers.",
      table: tournamentGrandChampionTable,
    },
    {
      title: "Overall Billfish",
      description: "First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
      table: overallBillfishTable,
    },
    {
      title: "Grand Slam",
      description: "Winner takes all. Earliest catch for tie-breakers.",
      table: grandSlamTable,
    },
    {
      title: "Billfish - Day 1",
      description: "Winner takes all each day. Earliest catch for tie-breakers.",
      table: billfishDay1Table,
    },
    {
      title: "Billfish - Day 2",
      description: "Winner takes all each day. Earliest catch for tie-breakers.",
      table: billfishDay2Table,
    },
    {
      title: "Billfish - Day 3",
      description: "Winner takes all each day. Earliest catch for tie-breakers.",
      table: billfishDay3Table,
    },
    {
      title: "Blue Marlin",
      description: "First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
      table: blueMarlinTable,
    },
    {
      title: "White Marlin",
      description: "First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
      table: whiteMarlinTable,
    },
    {
      title: "Sailfish",
      description: "First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
      table: sailfishTable,
    },
    {
      title: "Dolphin (Dorado, Mahi)",
      description: "Heaviest catch. First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
      table: dolphinTable,
    },
    {
      title: "Wahoo",
      description: "Heaviest catch. First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
      table: wahooTable,
    },
    {
      title: "Tuna",
      description: "Heaviest catch. First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
      table: tunaTable,
    },
    // {
    //   title: "Blue Marlin Pots",
    //   description: "First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "White Marlin Pots",
    //   description: "First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Sailfish Pots",
    //   description: "First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Dolphin (Dorado, Mahi) Pots",
    //   description: "First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Wahoo Pots",
    //   description: "First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Tuna Pots",
    //   description: "First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Overall Billfish Pots",
    //   description: "First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Non-Sonar Billfish Release",
    //   description: "First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Billfish Day 1 Pot",
    //   description: "Winner takes all. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Billfish Day 2 Pot",
    //   description: "Winner takes all. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Billfish Day 3 Pot",
    //   description: "Winner takes all. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Grand Slam Pot",
    //   description: "Winner takes all. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Grand Overall Pot",
    //   description: "Winner takes all. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Captain and Mate - Mate",
    //   description: "Winner takes all. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
    // {
    //   title: "Captain and Mate - Captain",
    //   description: "Winner takes all. Earliest catch for tie-breakers.",
    //   table: defaultTable,
    // },
  ]

  const delay = 30000;
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);
  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {

    // Get tournament grand champion
    let grandChampionParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getAllPointFish',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish1: "Blue Marlin",
        fish2: "White Marlin",
        fish3: "Sailfish",
        fish4: "Spearfish",
        fish5: "Dolphin (Dorado, Mahi)",
        fish6: "Wahoo",
        fish7: "Tuna",
      })
    }
    const getGrandChampion = async () =>{
      let response = await axios(grandChampionParams);  
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        let displayTable = buildPointsTable(result.slice(0,5))
        setTournamentGrandChampionTable(displayTable);
      }
    }
    getGrandChampion();

    // Get overall billfish
    let billfishOverallParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getAllBillfish',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish1: "Blue Marlin",
        fish2: "White Marlin",
        fish3: "Sailfish",
        fish4: "Spearfish",
      })
    }
    const getBillfishOverall = async () =>{
      let response = await axios(billfishOverallParams);  
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        let displayTable = buildPointsTable(result.slice(0,5))
        // setBillfishOverallTable(displayTable);
      }
    }
    getBillfishOverall();

    // Get Billfish Day 1
    let billfishDay1Params = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpeciesByDay',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish1: "Blue Marlin",
        fish2: "White Marlin",
        fish3: "Sailfish",
        fish4: "Spearfish",
        date: "2023-07-13",
      })
    }
    const getBillfishDay1 = async () =>{
      let response = await axios(billfishDay1Params);  
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        let displayTable = buildPointsTable(result.slice(0,5))
        setBillfishDay1Table(displayTable);
      }
    }
    getBillfishDay1();

    // Get Billfish Day 2
    let billfishDay2Params = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpeciesByDay',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish1: "Blue Marlin",
        fish2: "White Marlin",
        fish3: "Sailfish",
        fish4: "Spearfish",
        date: "2023-07-14",
      })
    }
    const getBillfishDay2 = async () =>{
      let response = await axios(billfishDay2Params);  
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        let displayTable = buildPointsTable(result.slice(0,5))
        setBillfishDay2Table(displayTable);
      }
    }
    getBillfishDay2();

    // Get Billfish Day 3
    let billfishDay3Params = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpeciesByDay',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish1: "Blue Marlin",
        fish2: "White Marlin",
        fish3: "Sailfish",
        fish4: "Spearfish",
        date: "2023-07-15",
      })
    }
    const getBillfishDay3 = async () =>{
      let response = await axios(billfishDay3Params);  
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        let displayTable = buildPointsTable(result.slice(0,5))
        // setBillfishDay3Table(displayTable);
      }
    }
    getBillfishDay3();

    // Get Blue Marlin
    let blueMarlinParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "Blue Marlin",
      })
    }
    const getBlueMarlin = async () =>{
      let response = await axios(blueMarlinParams);  
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        let displayTable = buildPointsTable(result.slice(0,5))
        setBlueMarlinTable(displayTable);
      }
    }
    getBlueMarlin();

    // Get White Marlin
    let whiteMarlinParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "White Marlin",
      })
    }
    const getWhiteMarlin = async () =>{
      let response = await axios(whiteMarlinParams);  
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        let displayTable = buildPointsTable(result.slice(0,5))
        setWhiteMarlinTable(displayTable);
      }
    }
    getWhiteMarlin();

    // Get Sailfish
    let sailfishParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "Sailfish",
      })
    }
    const getSailfish = async () =>{
      let response = await axios(sailfishParams);  
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});

        result.sort((a, b) => b.points - a.points);
        let displayTable = buildPointsTable(result.slice(0,5))
        setSailfishTable(displayTable);
      }
    }
    getSailfish();

    // Get Dolphin (Dorado, Mahi)
    let dolphinParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "Dolphin (Dorado, Mahi)",
      })
    }
    const getDolphin = async () =>{
      let response = await axios(dolphinParams);  
      var result = [];
      if(response.data.length > 0) {
        result = response.data.sort((a, b) => b.points - a.points);
        let displayTable = buildPointsTable(result.slice(0,5))
        setDolphinTable(displayTable);
      }
    }
    getDolphin();
    
    // Get Wahoo
    let wahooParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "Wahoo",
      })
    }
    const getWahoo = async () =>{
      let response = await axios(wahooParams);  
      var result = [];
      if(response.data.length > 0) {
        result = response.data.sort((a, b) => b.points - a.points);
        let displayTable = buildPointsTable(result.slice(0,5))
        setWahooTable(displayTable);
      }
    }
    getWahoo();

    // Get Tuna
    let tunaParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "Tuna",
      })
    }
    const getTuna = async () =>{
      let response = await axios(tunaParams);  
      var result = [];
      if(response.data.length > 0) {
        result = response.data.sort((a, b) => b.points - a.points);
        let displayTable = buildPointsTable(result.slice(0,5))
        // setTunaTable(displayTable);
      }
    }
    getTuna();

    // Handle time outs
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === results.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );
    return () => {
      resetTimeout();
    };

  }, [index]);

  return (
    <div className="slideshow">
      <div
        className="slideshowSlider"
        style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
      >
        {results.map((result, index) => (
          <div
            className="slide"
            key={index}
            // style={{ "#0088FE" }}
          >
            <h2>{result['title']}</h2>
            <p>{result['description']}</p>
            {result['table']}
          </div>
        ))}
      </div>

      <div className="slideshowDots">
        {results.map((_, idx) => (
          <div
            key={idx}
            className={`slideshowDot${index === idx ? " active" : ""}`}
            onClick={() => {
              setIndex(idx);
            }}
          ></div>
        ))}
      </div>
    </div>
  );
}

export default PublicSlideshow;

